import React from 'react';
import { FadeIn } from './FadeIn';
export function Empathy() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-30">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-31">
        <FadeIn data-id="element-32">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8" data-id="element-33">
            No es solo un número. <br className="hidden md:block" data-id="element-34" />
            <span className="text-brand-amber" data-id="element-35">Es tu tranquilidad.</span>
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg md:text-xl text-slate-600 leading-relaxed" data-id="element-36">
          <FadeIn delay={0.1} data-id="element-37">
            <p data-id="element-38">
              Sabes lo que se siente. Trabajas duro, cuidas a tu familia, pero
              al intentar dar el siguiente paso —esa casa propia, un vehículo
              confiable o un respaldo para emergencias— el sistema te frena. Un
              error del pasado no debería ser una cadena perpetua financiera.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-39">
            <p data-id="element-40">
              En{' '}
              <strong className="text-slate-900 font-semibold" data-id="element-41">
                Reinoso Business Consultant LLC
              </strong>
              , no solo "limpiamos" reportes. Restauramos tu capacidad de
              proyectar un futuro sin límites. Si el sistema te ha fallado con
              información incorrecta, obsoleta o injusta, nosotros nos
              encargamos de que la ley trabaje a tu favor.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}